import { ChatMessage } from "../protocol/messages/chat-message";
import { AbstractPlayer } from "../types/abstract-player";
import { GameItem } from "../types/game-item";
import { LoggedInPlayer } from "../protocol/dto/logged-in-player";
import { RoomItem } from "../types/room-item";
import { Player } from "../game/player";
import { SettingsModel } from "../types/settings-model";

/**
 * This is used to define Vuex store state type.
 */
export type State = {
  // login and user
  loading: boolean;
  user: LoggedInPlayer | undefined;
  rooms: RoomItem[];
  selectedRoomId: string;
  selectedGameKind: string;
  joinedRoom: RoomItem;
  userConnected: boolean;

  // main game windows
  isLoginShown: boolean;
  isRoomsShown: boolean;

  // chat and room panel
  playerList: AbstractPlayer[];
  chatMessages: ChatMessage[];

  // info modal
  isShowInfoModal: boolean;
  infoText: string;

  // send new game invite modal
  invitedPlayerId: string;

  // accept new game invite modal
  isShowInvitationRequestModal: boolean;
  inviteGame: GameItem;
  inviteText: string;

  // wait for opponent modal
  isShowWaitForOpponentModal: boolean;

  // join tournament modal
  isJoinTournamentModal: boolean;
  tournamentRoom: RoomItem,
  isRegistered: boolean,

  // game and player status
  player1: Player;
  player2: Player;
  playTurn: string;

  // settings
  settings: SettingsModel;
};

/**
 * This is to initalize Vuex store state.
 *
 * The Vuex store is used to help the application communicate with the front end views.
 */
export const state: State = {
  // login and user
  loading: false,
  user: undefined,
  rooms: [],
  //@ts-ignore
  selectedRoomId: null,
  //@ts-ignore
  selectedGameKind: null,
  //@ts-ignore
  joinedRoom: null,
  userConnected: false,

  // main game windows
  isLoginShown: true,
  isRoomsShown: false,
  
  // chat and room panel
  playerList: [],
  chatMessages: [],

  // info modal
  isShowInfoModal: false,
  infoText: '',

  // send new game invite modal
  invitedPlayerId: '',

  // accept new game invite modal
  isShowInvitationRequestModal: false,
  //@ts-ignore
  inviteGame: null,
  inviteText: '',

  // wait for opponent modal
  isShowWaitForOpponentModal: false,

  // join tournament modal
  isJoinTournamentModal: false,
  //@ts-ignore
  tournamentRoom: null,
  isRegistered: false,

  // game and player status
  //@ts-ignore
  player1: null,
  //@ts-ignore
  player2: null,
  playTurn: '',

  // settings
  //@ts-ignore
  settings: null,
};
